// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jrvLCNUCaJvtctFAzNK_,.Ra_lMPy7y3n1ylCFZ7se{grid-column:1/-1}.jrvLCNUCaJvtctFAzNK_{display:flex;flex-direction:row;justify-content:center;align-items:center}.DWUYcKHSKqle_34P6BdU{margin-bottom:50px;grid-column:1/-1}@media(max-width: 767px){.DWUYcKHSKqle_34P6BdU{margin-bottom:28px}}.DWUYcKHSKqle_34P6BdU>*{margin-bottom:20px}.DWUYcKHSKqle_34P6BdU>*:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showMore": "jrvLCNUCaJvtctFAzNK_",
	"textTitle": "Ra_lMPy7y3n1ylCFZ7se",
	"containerCards": "DWUYcKHSKqle_34P6BdU"
};
export default ___CSS_LOADER_EXPORT___;
